<ion-button
  fill="clear"
  color="danger"
  [attr.aria-label]="'users.delete' | translate"
  (click)="confirmDelete()"
  [disabled]="!canRemove()"
>
  <ion-icon
    slot="icon-only"
    aria-hidden="true"
    src="../assets/material-symbols/delete_24dp.svg"
  ></ion-icon>
</ion-button>
